import MuiFormLabel, { FormLabelProps } from '@mui/material/FormLabel';

export interface IFormLabelProps extends FormLabelProps {}

const FormLabel = (props: IFormLabelProps): JSX.Element => {
  return <MuiFormLabel {...props} />;
};

export default FormLabel;
